module.exports = __webpack_public_path__ + "img/about-decoration-2.b1d49402.jpg";